import { Component, OnInit, OnChanges } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import 'rxjs/add/operator/map';
import { ClientService } from '../client.service';
import { OAuthClientDetail } from '../oauth-client-detail';
import { ClientDto } from '../client-dto';
import { UserService } from '../../common/api/user.service';

@Component({
    selector : 'app-client-new',
    templateUrl : './client-new.component.html',
})
export class ClientNewComponent implements OnInit {

    // client = new OAuthClientDetail();
    client = new ClientDto();

    constructor(public router: Router, private clientService: ClientService, private userService: UserService) {}

    ngOnInit() {

    }

    createClient() {
      if (this.client.clientName == null || this.client.clientName.length < 1) {
        alert('클라이언트ID에 연결할 이름을 입력해주세요 ');
        return;
      }

      if (this.client.clientEmail == null || this.client.clientEmail.length < 1) {
        alert('연락 가능한 이메일을 입력해주세요');
        return;
      }

      const grantTypes = new Array<string>();
      $($('input[name=grantTypes]:checkbox').each(function() {
        if ($(this).is(':checked')) {
          grantTypes.push($(this).val());
        }
      }));

      if (grantTypes.length < 1) {
        alert('권한 부여 타입을 하나 이상 선택해주세요.');
        return;
      }

      this.client.grantTypes = grantTypes;

      const scopes = new Array<string>();
      $($('input[name=scope]:checkbox').each(function() {
        if ($(this).is(':checked')) {
          scopes.push($(this).val());
        }
      }));

      if (scopes.length < 1) {
        alert('스코프를 하나 이상 선택해주세요.');
        return;
      }

      this.client.scopes = scopes;

      this.clientService.createClient(this.client).subscribe(response => {
        alert('등록되었습니다.');
        this.router.navigate(['/client/list']);
      }, error => {
        if (error.status === 401) {
          alert('로그인이 만료되었거나 잘못된 인증입니다.\n다시 로그인 해주세요');
          this.userService.logout();
        } else {
          alert('오류가 발생했습니다.');
        }
      });
    }


}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/d90c5bcf/0/gaia/gaia-ui-angular/src/app/client/new/client-new.component.ts